import { SET_AND_FORGET_PROMO_MIN_MANUAL_CONSENT_ACTIVATIONS, USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign } from '../alerts.types'

export const setAndForgetPromoModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.SET_AND_FORGET_PROMO,
  priority: ALERT_CAMPAIGN_PRIORITIES.SET_AND_FORGET_PROMO,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.SET_AND_FORGET_PROMO],
  isEligible: (context) => {
    if (context.profile === null) {
      return false
    }

    if (
      context.profile.usage_mode !== 'customer' ||
      context.userEvents.has(USER_EVENTS.SET_AND_FORGET_PROMO_MODAL_SEEN)
    ) {
      return false
    }

    const { setAndForgetPromo } = context

    if (setAndForgetPromo.autoActivateWhenClear) {
      return false
    }

    return setAndForgetPromo.manualConsentActivationCount >= SET_AND_FORGET_PROMO_MIN_MANUAL_CONSENT_ACTIVATIONS
  },
}
